import * as t from 'io-ts';
import { authorizedTo, id, meta, entityItem } from '../..';
import { getEnumCodec } from '@/types';

export enum GATEWAY_STATUS {
  CONNECTED = 1,
  NOT_CONNECTED = 0,
}

export const status = t.type({
  connected: getEnumCodec<GATEWAY_STATUS>('GATEWAY_STATUS', GATEWAY_STATUS),
  interfaces: t.array(t.string),
  ssid: t.union([t.string, t.null]),
});

const data = t.type({
  title: t.string,
  deviceId: t.string,
  entityItem: t.union([entityItem, t.null]),
  status,
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

export const formCodec = t.type({
  title: t.string,
  entityItem: t.union([t.number, t.null]),
});
